export var teplo_t1 = {
    name: "Графики температур после теплообменника",
    valuetitle: '°C',
    ps: {
        'ti_6_96_5': { caption: "Т5 - температура подачи с теплообменника на нагрузки"},
        'ti_6_96_9': { caption: "Т9 - температура на теплообменник с нагрузки"}
    }
};
export var teplo_t2 = {
    name: "Графики температур до теплообменника",
    valuetitle: '°C',
    ps: {
        'ti_6_96_3': {caption:"Т3 - температура подачи на теплообменник от генератора"},
        'ti_6_96_6': {caption:"Т6 - температура обратки с теплообменника на генератор"},
        'ti_6_96_21':{caption:"1Тз - Задание температуры перехода на теплоцентраль"}

    }
};
export var teplo_t3 ={
    name: "График температуры в баке аккумуляторе",
    valuetitle: '°C',
    ps:  {
        'ti_6_96_4': {caption:"Т4 -температура в баке аккумуляторе"},
        'ti_6_96_22':{ caption:"2Тз - Задание минимальной температуры в баке аккумуляторе"}
    }
};
export var teplo_t4 ={
    name: "Графики температуры на котле",
    valuetitle: '°C',
    ps: {
        'ti_6_94_9': {caption: "2Тп - температура подачи с котла"},
        'ti_6_94_10': {caption: "2То - температура обратки на котел"}
    }
};
export var teplo_t5 = {
    name: "Графики температур на нагрузку",
    valuetitle: '°C',
    ps: {
        'ti_6_96_2': {caption:"Т2- температура подачи на нагрузку"},
        'ti_6_96_23': {caption:"ЗТз - Задание температуры подачи на нагрузку"}
    }
};
export var teplo_t6 = {
    name: "Графики температуры на нагрузке",
    valuetitle: '°C',
    ps: {
        'ti_6_94_7': {caption: "1Тп - температура на нагрузку"},
        'ti_6_94_8' : {caption: "1То - температура с нагрузки"}
    }
};
export var teplo_t7 = {
    name: "Графики температуры наружного воздуха",
    valuetitle: '°C',
    ps:  {
       'ti_6_96_1': {caption:"Т1 - температура наружного воздуха"},
       'ti_6_96_66': {caption:"Средняя температура наружного воздуха за сутки"}
    }
};
export var teplo_t8 = {
    name: "График температуры воздуха в отделе заказов",
    valuetitle: '°C',
    ps: {
        'ti_6_96_8': {caption: "Термометр-8 Температура в Отделе заказов"}
    }};
export var teplo_t9 = {
    name: "График температуры воздуха в ИТП",
    valuetitle: '°C',
    ps: {
        'ti_6_96_7': {caption: "Т7 - темепература воздуха в ИТП"}
    }
};
export var gidro_t1 = {
    name: "График расхода теплоносителя через котел",
    valuetitle: 'м\xB3/ч',
    ps: {
        'ti_6_91_2': {caption: "QЭ – расход теплоносителя через котел"}
    }
};
export var gidro_t2 = {
    name: "График расхода теплоносителя через ТО",
    valuetitle: 'м\xB3/ч',
    ps: {
        'ti_6_94_26': {caption: "Qр – расход теплоносителя через ТО"}
    }
};
export var gidro_t3 = {
    name: "График расхода сетевой воды",
    valuetitle: 'м\xB3/ч',
    ps: {
        'ti_6_94_25': {caption: "Qн – расход сетевой воды"}
    }
};
export var electro_t1 = {
    name: "График напряжения, В.",
    valuetitle: 'В',
    ps: {
        'ti_6_93_141': {caption: 'Напряжение фаза \"А\"'},
        'ti_6_93_142': {caption: 'Напряжение фаза \"B\"'},
        'ti_6_93_143': {caption: 'Напряжение фаза \"C\"'}
    }
};
export var electro_t2 = {
    name: "График тока, А.",
    valuetitle: 'А',
    ps: {
        'ti_6_93_151': {caption: 'Ток фаза\"А\"'},
        'ti_6_93_152': {caption: 'Ток фаза\"B\"'},
        'ti_6_93_153': {caption: 'Ток фаза\"C\"'}
    }
};





// WEBPACK FOOTER //
// ./src/trends.js